import React from "react";
import { motion } from "framer-motion";
import { MessageCircle, ArrowRight } from "lucide-react";
import { useLang } from "../../i18n/LanguageContext";
import { WHATSAPP_URL } from "../../i18n/translations";

export default function CTAFinal() {
  const { t } = useLang();
  return (
    <section id="contact" className="relative py-20 md:py-28 overflow-hidden">
      <div className="max-w-6xl mx-auto px-5 md:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="relative rounded-[2rem] p-10 md:p-16 text-center overflow-hidden border border-brand-orange/25 bg-gradient-to-br from-[#1a0f08] via-[#0f0a0a] to-[#0a0b0e]"
        >
          {/* Glow */}
          <div className="absolute inset-0 -z-10 glow-orange-strong" />
          <div className="absolute -top-32 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-brand-orange/15 blur-[120px] rounded-full" />
          <div className="absolute inset-0 bg-[radial-gradient(rgba(249,115,22,0.06)_1px,transparent_1px)] [background-size:24px_24px] [mask-image:radial-gradient(ellipse_at_center,black,transparent_70%)]" />

          <motion.h2
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.05 }}
            className="text-3xl md:text-5xl lg:text-6xl font-semibold tracking-tighter text-white leading-tight"
            data-testid="final-cta-title"
          >
            {t.finalCta.title}
          </motion.h2>

          <motion.p
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.15 }}
            className="mt-5 max-w-2xl mx-auto text-base md:text-lg text-white/70 leading-relaxed"
          >
            {t.finalCta.subtitle}
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.25 }}
            className="mt-9"
          >
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noreferrer"
              data-testid="final-cta-whatsapp"
              className="group inline-flex items-center gap-3 bg-brand-orange hover:bg-brand-orangeHover text-white rounded-full px-8 py-4 text-base md:text-lg font-medium transition-all shadow-[0_0_32px_rgba(249,115,22,0.5)] hover:shadow-[0_0_50px_rgba(249,115,22,0.7)] hover:-translate-y-0.5"
            >
              <MessageCircle size={20} />
              {t.finalCta.cta}
              <ArrowRight size={20} className="transition-transform group-hover:translate-x-1" />
            </a>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}
